import { MainLayout } from "@/components/MainLayout";
import { ConstructionDashboard } from "@/components/construction/ConstructionDashboard";

export default function ConstructionDashboardPage() {
  return (
    <MainLayout>
      <div className="container mx-auto py-6">
        <ConstructionDashboard />
      </div>
    </MainLayout>
  );
}
